import api from './api';

export interface FtthArmario {
  id: number;
  name: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  status: 'ativo' | 'inativo' | 'aguardando_instalacao' | 'manutencao';
  color?: string | null;
  icon?: string | null;
  color_text?: string | null;
  escritorio_id: number;
  pontos_id?: number[]; // IDs dos pontos de cabos vinculados a este armário
  usuarioId_criou: number;
  createdAt: string;
  updatedAt: string;
  usuario_criou?: {
    id: number;
    nome: string;
    usuario: string;
  };
  escritorio?: {
    id: number;
    identificacao: string;
    cidade: string;
  };
}

class FtthArmarioService {
  async getArmarios(params?: {
    page?: number;
    limit?: number;
    status?: string;
    search?: string;
    escritorio_id?: number;
  }) {
    const response = await api.get('/ftth-armarios', { params });
    return response.data;
  }

  async getById(id: number): Promise<{ success: boolean; data: FtthArmario }> {
    const response = await api.get(`/ftth-armarios/${id}`);
    if (response.data && typeof response.data === 'object' && 'success' in response.data) {
      return response.data;
    }
    return { success: true, data: response.data };
  }

  async create(data: Partial<FtthArmario>): Promise<{ success: boolean; data: FtthArmario }> {
    const response = await api.post('/ftth-armarios', data);
    return response.data;
  }

  async update(id: number, data: Partial<FtthArmario>): Promise<{ success: boolean; data: FtthArmario }> {
    const response = await api.put(`/ftth-armarios/${id}`, data);
    return response.data;
  }

  async delete(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/ftth-armarios/${id}`);
    return response.data;
  }
}

export const ftthArmarioService = new FtthArmarioService();
